import { useState } from 'react';
import { api } from '../lib/api';
import { useSession } from '../lib/session';
import { ROLE_LABEL } from '../lib/labels';
import { Alert, Badge, Button, Card, PageHeader, errorMessage } from '../components/ui';
import { RecoveryCodeList } from './LoginPage';
import { PasswordForm } from './PasswordForm';

function RecoveryCodesCard() {
  const { me, reload } = useSession();
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [codes, setCodes] = useState<string[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  if (!me?.user.mfaEnabled) {
    return (
      <Card title="Verificação em duas etapas">
        <p className="text-sm text-slate-600">
          MFA não está ativo para sua conta. Ele é obrigatório para administradores.
        </p>
      </Card>
    );
  }
  return (
    <Card title="Verificação em duas etapas">
      <div className="space-y-4">
        <p className="text-sm text-slate-700">
          <Badge tone="emerald">Ativo</Badge> · Códigos de recuperação restantes:{' '}
          <strong>{me.user.recoveryCodesRemaining}</strong>
        </p>
        {error && <Alert tone="error">{error}</Alert>}
        {codes ? (
          <>
            <Alert tone="warning">
              Novos códigos gerados. Os anteriores deixaram de valer. Guarde estes agora: não serão
              mostrados de novo.
            </Alert>
            <RecoveryCodeList codes={codes} />
            <Button
              variant="secondary"
              onClick={() => void navigator.clipboard?.writeText(codes.join('\n'))}
            >
              Copiar códigos
            </Button>
          </>
        ) : confirming ? (
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm text-slate-700">Os códigos atuais deixarão de funcionar.</span>
            <Button
              busy={busy}
              onClick={async () => {
                setBusy(true);
                setError(null);
                try {
                  const r = await api.post<{ recoveryCodes: string[] }>(
                    '/v1/me/mfa/recovery-codes',
                  );
                  setCodes(r.recoveryCodes);
                  await reload();
                } catch (e) {
                  setError(errorMessage(e));
                } finally {
                  setBusy(false);
                  setConfirming(false);
                }
              }}
            >
              Gerar novos códigos
            </Button>
            <Button variant="ghost" onClick={() => setConfirming(false)}>
              Cancelar
            </Button>
          </div>
        ) : (
          <Button variant="secondary" onClick={() => setConfirming(true)}>
            Gerar novos códigos de recuperação
          </Button>
        )}
      </div>
    </Card>
  );
}

export function AccountPage() {
  const { me, role } = useSession();
  if (!me) return null;
  return (
    <>
      <PageHeader title="Minha conta" />
      <div className="grid gap-6 lg:grid-cols-2">
        <Card title="Perfil">
          <dl className="grid grid-cols-[8rem_1fr] gap-y-2 text-sm">
            <dt className="text-slate-500">Nome</dt>
            <dd className="text-slate-900">{me.user.name}</dd>
            <dt className="text-slate-500">E-mail</dt>
            <dd className="break-all text-slate-900">{me.user.email}</dd>
            <dt className="text-slate-500">Papel atual</dt>
            <dd>{role ? <Badge>{ROLE_LABEL[role]}</Badge> : '—'}</dd>
          </dl>
        </Card>
        <RecoveryCodesCard />
        <Card title="Alterar senha" className="lg:col-span-2">
          <div className="max-w-md">
            <PasswordForm onChanged={() => undefined} />
          </div>
        </Card>
      </div>
    </>
  );
}
